import {Paper} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from '@material-ui/lab/Alert';
import 'Agent/AgentForms/Marketing/components/MarketingViewCart.sass';
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import {
    changeCartVisibility,
    clearViewCart,
    removeCartItems,
    useGreenAlertStyles
} from "Agent/AgentForms/Marketing/ducks/Marketing";
import {AsyncError, Pending, toEither} from "Core/models/Async";
import * as E from 'fp-ts/lib/Either';
import {pipe} from "fp-ts/lib/pipeable";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ReducerState} from "rootReducer";
import ErrorPage from "Shared/components/ErrorPage";

export type VCSubmissionProps = {
    setIsViewCartBlock: (value: boolean | ((isViewCartBlock: boolean) => boolean)) => void;
};

const VCSubmission = ({setIsViewCartBlock}: VCSubmissionProps) => {
    const classes = useGreenAlertStyles();
    const {inCartVisible, viewCart, formOrder} = useSelector((state: ReducerState) => state.marketing);
    const [updatedCart, setUpdatedCart] = useState(viewCart);
    const dispatch = useDispatch();

    const renderOrderAsync = (asyncError: Pending | AsyncError, onLoading?: () => JSX.Element) => {
        switch (asyncError.key) {
            case 'Empty':
            case 'Loading':
                return onLoading ? onLoading() : <div style={{padding: '2rem'}}><LinearProgress/></div>;
            case 'ServerError':
            case 'Unauthorized':
            case 'Conflict':
            case 'NotFound':
            default:
                return <Paper square elevation={0} className={classes.resetContainer}>
                    <div>
                        <ErrorPage error={asyncError}/>
                    </div>
                    <p/>
                    <div>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={(e => confirmationNavigate())}
                            className={viewCart.items.size >= 1 ? classes.button : classes.disabledButton}
                        >
                            Close
                        </Button>
                    </div>
                </Paper>
                    ;
        }
    };

    const confirmationNavigate = () => {
        setIsViewCartBlock(false)
        removeCartItems(inCartVisible, updatedCart, setUpdatedCart);
        dispatch(changeCartVisibility({...inCartVisible}));
        dispatch(clearViewCart());
    }

    return (
        pipe(
            toEither(formOrder),
            E.fold(renderOrderAsync, orderDetail => {
                return (
                    <Paper square elevation={0} className={classes.resetContainer}>
                        <Alert severity="success" variant="filled" className={classes.greenAlert}>
                            Order <strong>{orderDetail.orderId}</strong> has been <strong>submitted
                            successfully!</strong>
                        </Alert>

                        <Button
                            id="btnOrderMoreForms"
                            style={{padding: '.5rem'}}
                            variant='contained'
                            color='primary'
                            onClick={(e => confirmationNavigate())}
                            className={classes.button}
                        >
                            Order More Forms
                        </Button>

                    </Paper>
                )
            })
        )
    )
}

export default VCSubmission;
